import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
  en: {
    manage_question: {
      approved: 'Approved',
      category: 'Category',
      can_be_skipped: 'Can be skipped',
      btn_save_and_notify: 'Save and Notify',
      display: 'Display',
      icon: 'Icon',
      subcategory: 'Subcategory',
      question_type: 'Question Type',
      unit: 'Unit',
    },
    stauHeatMapHeadline: 'Congestion times outside stops',
    TripDetailInfos: 'Trip details',
    Counted: 'Counted',
    Total: 'Total',
    Total_number_of_trips: 'Total number of trips',
    Number_of_trips_counted: 'Number of trips counted',
    totalNumberTrips: '# trips total',
    totalPercentFGZS: 'Trips with passenger count',
    totalAverageCapacity: 'average capacity utilization',
    totalAverageDelay: 'average difference',
    Sort_order: 'Sort Order',
    over90capacityTrips: '* trips with over x capacity reached',
    totalOver90capacityTrips: 'total counted',
    countedPassengers: '* passengers counted',
    estimatedCountedPassengers: 'extrapolated total',
    estimatedOver90capacityTrips: 'extrapolated total',
    totalCountedPassengers: 'total counted',
    Occupancy: 'Occupancy',
    inefficient: 'Low capacity utilisation',
    allSeated: 'Seats available',
    totalCapacity: 'Seats occupied',
    overload: 'High capacity utilisation',
    Proportion_of_trips_with_respective_classification: 'Proportion of trips with respective classification',
    Adjust: 'Adjust',
    Adjust_initial_delay: 'Adjust initial delay',
    Average_number_of_passengers: 'Average number of passengers',
    Normalised_average_number_of_passengers: 'Normalised average number of passengers',
    Number_of_trips_with_passenger_counting_system: 'Number of trips with passenger counting system',
    please_chose_trip: 'Please choose trip',
    FilterAndAddInfos: 'Filter & Additional Info',
    Warning: 'Warning',
    Ups: 'Ups',
    Filter: 'Filter',
    vacation: 'vacation',
    holiday: 'holiday',
    AdditionalInfo: 'Additional Info',
    There_are_no_data_for_chosen_filters: 'There are no data for chosen filters',
    please_chose_the_time: 'Please chose the time',
    please_chose_the_date: 'Please chose the date',
    Date: 'Date',
    Time: 'Time',
    Directions: 'Directions',
    to: 'to',
    Create_graphics_with_current_filters: 'Create graphics with current filters',
    confirm_password: 'Confirm password',
    password_was_copied: 'Password was copied',
    chose_the_language: 'Chose the language',
    the_language_was_updated: 'The language was updated',
    language: 'Language',
    german: 'German',
    english: 'English',
    Statistics: 'Statistics',
    ride_time: 'Delay analysis',
    Passengers: 'Passengers',
    Update_visualisation: 'Update visualisation',
    All: 'All',
    None: 'None',
    Night: 'Night',
    Evening: 'Evening',
    Working_day: 'Working day',
    Early_morning: 'Early morning',
    Define_area: 'Define area',
    Mon: 'Mon',
    Tue: 'Tue',
    Wed: 'Wed',
    Thu: 'Thu',
    Fri: 'Fri',
    Sat: 'Sat',
    Sun: 'Sun',
    please_chose_the_line: 'Please chose the line',
    add_new_row: 'Add new',
    Period: 'Period',
    load_recent_filters: 'Load recent filters',
    fpj: 'Year',
    fpj_short: 'Year',
    days: 'Days',
    time_range: 'Time range',
    line: 'Line',
    direction: 'Direction',
    the_filter_was_updated: 'The filter was updated',
    search: 'Search',
    assign_scope_for_the_role: 'Assign scope for the role',
    has_already_all_scopes: 'Has already all scopes',
    For_the_role: 'For the role',
    please_chose_the_user: 'Please chose the user',
    company_name: 'Organization name',
    The_company_was_created: 'The organization was created',
    credentials_were_deleted: 'Credentials were deleted',
    please_chose_the_scopes: 'Please chose the scopes',
    choose_language: 'Please select language',
    The_role_was_assigned: 'The role was assigned',
    first_name: 'First name',
    last_name: 'Last name',
    the_user_was_created: 'The user was created',
    has_all_roles: 'has all roles',
    please_chose_the_role: 'Please chose the role',
    For: 'For',
    reset: 'Reset',
    edit: 'Edit',
    create_new: 'Create new',
    Cancel: 'Cancel',
    password_was_updated: 'Password was updated',
    save_new_password: 'Save new password',
    new_password: 'New password',
    reset_password: 'Reset password',
    Delete: 'Delete',
    delete: 'delete',
    to_or_want: 'to',
    please_confirm_this_action: 'Please confirm this action',
    are_you_sure_you_want_to: 'Are you sure you want',
    the_user_was_deleted: 'The user was deleted',
    the_new_role_was_assigned: 'The new role was assigned',
    The_role_was_removed: 'The role was removed',
    this_company: 'This Organization',
    delete_company: 'Delete Organization',
    delete_this_company: 'Delete this Organization',
    The_company_was_deleted: 'The Organization was deleted',
    The_new_role_was_assigned: 'The new role was assigned',
    The_role_was_deleted: 'The role was deleted',
    No_roles_are_assigned_for_this_user_yet: 'No roles are assigned for this user yet',
    Remove_this_role: 'Remove this role',
    this_role: 'this role',
    remove_role: 'Remove role',
    Assign_new_role: 'Assign new role',
    Users: 'Users',
    There_are_no_companies_yet: 'There are no companies yet',
    Create_new_company: 'Create new Organization',
    Companies: 'Companies',
    the_role_was_updated: 'The role was updated',
    the_users_were_assigned: 'The users were assigned',
    the_user_was_removed: 'The user was removed',
    the_scopes_were_assigned: 'The scopes were assigned',
    the_scope_was_removed: 'The scope was removed',
    Successful: 'Successful',
    this_role_does_not_have_any_scopes: 'This role does not have any scopes',
    Hide: 'Hide',
    show_all_scopes: 'Show all scopes',
    remove_scope: 'Remove scope',
    this_scope: 'this scope',
    assign_new_scopes: 'Assign new scopes',
    scopes: 'Scopes',
    no_users_are_assigned_for_this_role_yet: 'No users are assigned for this role yet',
    remove: 'remove',
    remove_user: 'remove user',
    Remove: 'Remove',
    ID: 'ID',
    assign_new_user: 'Assign new user',
    assigned_users: 'Assigned users',
    update_description: 'update description',
    update_name: 'update name',
    name: 'Name',
    delete_this_user: 'delete this user',
    this_user: 'this user',
    delete_user: 'Delete user',
    roles: 'Roles',
    create_new_role: 'Create new role',
    this_company_does_not_have_any_roles: 'This Organization does not have any roles',
    Error: 'Error',
    edit_company_name: 'Edit Organization name',
    website: 'Website',
    edit_website: 'Edit website',
    description: 'Description',
    edit_description: 'Edit description',
    the_company_was_updated: 'The Organization was updated',
    this_company_does_not_have_any_users: 'This Organization does not have any users',
    DASHBOARD: 'DASHBOARD',
    PASSENGERS: 'PASSENGERS',
    CAPACITY: 'CAPACITY',
    passenger_capacity: 'Passenger Capacity',
    total_number_of_entries: 'Total Number Of Entries',
    maximum_occupancy: 'Maximum Occupancy',
    RIDE_TIME: 'DELAY ANALYSIS',
    ROUTES: 'ROUTES',
    congestion: 'Congestion',
    accessibility_of_stops: 'Accessibility Of Stops',
    data_quality: 'DATA QUALITY',
    average_number_of_passengers: 'Average Number Of Passengers',
    normalised_average_number_of_passengers: 'Normalised Average Number Of Passengers',
    passenger_counter: 'Passenger Counter',
    vehicle_deployment: 'VEHICLE DEPLOYMENT',
    raised_rides_lines: 'Raised Rides | Lines',
    raised_rides_wum: 'Raised Rides | WUM',
    statistics: 'STATISTICS',
    analysis: 'ANALYSIS',
    Customers: 'Customers',
    showRole: 'Show Role',
    User: 'User',
    Logout: 'Logout',
    Settings: 'Settings',
    myProfile: 'My Profile',
    welcome: 'Welcome',
    myPersonalData: 'My Personal Data',
    myCompany: 'My Organization',
    rightsManagement: 'Rights Management',
    superUserPage: 'Superuser Page',
    updateUser: 'Update user',
    updateUsername: 'Update username',
    save: 'Save',
    resetPassword: 'Reset password',
    thisCredentials: 'this credentials',
    deleteCredentials: 'Delete credentials',
    createNewCredentials: 'Create new credentials',
    validTill: 'valid till',
    Back: 'Back',
    credentials: 'Credentials',
    created: 'created',
    yes: 'Yes',
    no: 'No',
    allowLogin: 'Allow login',
    info: 'Info',
    privacyPolicy: 'Privacy policy',
    imprint: 'Imprint',
    brodtmannConsulting: 'Brodtmann Consulting',
    invalidCredentials: 'Invalid Credentials',
    signIn: 'SIGN IN',
    password: 'Password',
    email: 'E-mail',
    username: 'Username',
    company: 'Organization',
    longLoadingNotice: '...loading is taking longer than expected...',
    graphUpdating: 'graph is updating...',
    Trips: 'Trips',
  },
  de: {
    stauHeatMapHeadline: 'Stauzeiten ausserhalb von Haltestellen',
    TripDetailInfos: 'Einzelfahrt-Details',
    Total: 'Gesamt',
    Counted: 'Gezählt',
    Number_of_trips_counted: 'Anzahl Fahrten gezählt',
    Total_number_of_trips: 'Anzahl Fahrten gesamt',
    totalNumberTrips: '# Fahrten gesamt',
    totalPercentFGZS: 'Anteil Fahrten mit FGZS',
    totalAverageCapacity: 'mittlere maximale Auslastung',
    totalAverageDelay: 'mittlere Fahrplanabweichung',
    Sort_order: 'Sortier-Reihenfolge',
    over90capacityTrips: '* gezählte Fahrten mit Auslastung von mehr als X',
    totalOver90capacityTrips: 'übervolle Fahrten (80%+)',
    countedPassengers: '* gezählte Passagiere',
    totalCountedPassengers: 'ingesamt gezählt',
    estimatedCountedPassengers: 'hochgerechnet gesamt',
    estimatedOver90capacityTrips: 'hochgerechnet gesamt',
    Occupancy: 'Belegung',
    inefficient: 'Geringe Auslastung',
    allSeated: 'Sitzplätze verfügbar',
    totalCapacity: 'Sitzplätze belegt',
    overload: 'Hohe Auslastung',
    Proportion_of_trips_with_respective_classification: 'Anteil der Fahrten mit jeweiliger Klassifizierung',
    Adjust: 'Korrigieren',
    Adjust_initial_delay: 'Initiale Verspätung korrigieren',
    Average_number_of_passengers: 'Durchschnittliche Belegung',
    Normalised_average_number_of_passengers: 'Normalisierte durchschnittliche Anzahl Passagiere',
    Number_of_trips_with_passenger_counting_system: 'Anzahl von Fahrten mit Fahrgastzähl-System',
    please_chose_trip: 'Fahrt auswählen',
    FilterAndAddInfos: 'Filter & Zusatzinfos',
    Warning: 'Achtung',
    Ups: 'Ups',
    Filter: 'Filter',
    vacation: 'Ferien',
    holiday: 'Feiertag',
    AdditionalInfo: 'Zusätzliche Infos',
    There_are_no_data_for_chosen_filters: 'Es gibt keine Daten für ausgewählte Filter',
    please_chose_the_time: 'Zeit auswählen',
    please_chose_the_date: 'Datum auswählen',
    Date: 'Datum',
    Time: 'Zeit',
    Directions: 'Richtungen',
    to: 'bis',
    Create_graphics_with_current_filters: 'Grafik mit aktuellen Filtern erstellen',
    confirm_password: 'Passwort bestätigen',
    password_was_copied: 'Passwort wurde kopiert',
    chose_the_language: 'Sprache auswählen',
    the_language_was_updated: 'Die Sprache wurde geändert',
    language: 'Sprache',
    german: 'Deutsch',
    english: 'Englisch',
    Statistics: 'Statistik',
    ride_time: 'Fahrzeitprofile',
    Analysis: 'Analyse',
    Update_visualisation: 'Visualisierung aktualisieren',
    All: 'Alle',
    None: 'Keine',
    Night: 'Nacht',
    Evening: 'Abend',
    Working_day: 'Arbeitstag',
    Early_morning: 'früher Morgen',
    Define_area: 'Bereich bestimmmen',
    Mon: 'Mo',
    Tue: 'Di',
    Wed: 'Mi',
    Thu: 'Do',
    Fri: 'Fr',
    Sat: 'Sa',
    Sun: 'So',
    please_chose_the_line: 'Linie auswählen',
    add_new_row: 'Zeile hinzufügen',
    Period: 'Zeitraum',
    load_recent_filters: 'lade aktuelle Filter',
    fpj: 'Fahrplanjahr',
    fpj_short: 'FPJ',
    days: 'Tage',
    time_range: 'Tageszeit',
    line: 'Linie',
    direction: 'Fahrtrichtung',
    the_filter_was_updated: 'Filter wurde aktualisiert',
    search: 'Suchen',
    assign_scope_for_the_role: 'Rechte für Rolle zuordnen',
    has_already_all_scopes: 'hat schon alle Rechte',
    For_the_role: 'Für die Rolle',
    please_chose_the_user: 'Benutzer auswählen',
    company_name: 'Firmen Name',
    The_company_was_created: 'Kunde wurde erstellt',
    credentials_were_deleted: 'Zugangsdaten wurden erstellt',
    please_chose_the_scopes: 'Rechte auswählen',
    choose_language: 'Sprache wählen',
    The_role_was_assigned: 'Neue Rolle wurde zugeordnet',
    first_name: 'Vorname',
    last_name: 'Nachname',
    the_user_was_created: 'Der Benutzer wurde erstellt',
    has_all_roles: 'hat schon alle Rollen',
    please_chose_the_role: 'Rolle auswählen',
    For: 'Für',
    reset: 'Zurücksetzen',
    edit: 'Bearbeiten',
    create_new: 'Neu erstellen',
    Cancel: 'Abbrechen',
    password_was_updated: 'Passwort wurde aktualisiert',
    save_new_password: 'Neues Passwort speichern',
    new_password: 'Neues Passwort',
    reset_password: 'Passwort zurücksetzen',
    Delete: 'Löschen',
    delete: 'löschen',
    to_or_want: 'wollen',
    please_confirm_this_action: 'Bitte bestätigen Sie diese Aktion',
    are_you_sure_you_want_to: 'Sind Sie sicher, dass Sie',
    the_user_was_deleted: 'Benutzer wurde gelöscht',
    the_new_role_was_assigned: 'Neue Rolle wurde zugeordnet',
    The_role_was_removed: 'Die Rolle wurde entfernt',
    this_company: 'diese Firma',
    delete_company: 'Firma löschen',
    delete_this_company: 'Diese Firma löschen',
    The_company_was_deleted: 'Die Firma wurde gelöscht',
    The_new_role_was_assigned: 'Neue Rolle wurde zugeordnet',
    The_role_was_deleted: 'Die Rolle wurde entfernt',
    No_roles_are_assigned_for_this_user_yet: 'Für diesen Benutzer sind noch keine Rollen zugeordnet',
    Remove_this_role: 'Diese Rolle entfernen',
    this_role: 'diese Rolle',
    remove_role: 'Rolle entfernen',
    Assign_new_role: 'Neue Rolle zuordnen',
    Users: 'Benutzer',
    There_are_no_companies_yet: 'Im System gibt es noch keine Kunden',
    Create_new_company: 'Neuer Kunde erstellen',
    Companies: 'Kunden',
    the_role_was_updated: 'Die Rolle wurde aktualisiert',
    the_users_were_assigned: 'Die Benutzer wurden zugeordnet',
    the_user_was_removed: 'Benutzer wurde entfernt',
    the_scopes_were_assigned: 'Die Rechte wurden zugeordnet',
    the_scope_was_removed: 'Zugriffsrecht entfernt',
    Successful: 'Erfolgreich',
    this_role_does_not_have_any_scopes: 'diese Rolle hat keine Rechte',
    Hide: 'Verstecken',
    show_all_scopes: ' Alle Rechte anzeigen',
    remove_scope: 'Zugriffsrecht entfernen',
    this_scope: 'dieses Zugriffsrecht',
    assign_new_scopes: 'Neue Rechte zuordnen',
    scopes: 'Rechte',
    no_users_are_assigned_for_this_role_yet: 'Für diese Rolle sind noch keine Benutzer zugeordnet',
    remove: 'entfernen',
    remove_user: 'Benutzer entfernen',
    Remove: 'Entfernen',
    ID: 'ID',
    assign_new_user: 'Neue Benutzer zuordnen',
    assigned_users: 'Zugeordnete Benutzer',
    update_description: 'Beschreibung aktualisieren',
    update_name: 'Name aktualisieren',
    name: 'Name',
    delete_this_user: 'Diesen Benutzer löschen',
    this_user: 'diesen Benutzer',
    delete_user: 'Benutzer löschen',
    roles: 'Rollen',
    create_new_role: 'Neue Rolle erstellen',
    this_company_does_not_have_any_roles: 'Für diese Firma sind noch keine Rollen zugeordnet',
    Error: 'Fehler',
    edit_company_name: 'Firmenname bearbeiten',
    website: 'Webseite',
    edit_website: 'Webseite bearbeiten',
    description: 'Beschreibung',
    edit_description: 'Beschreibung bearbeiten',
    the_company_was_updated: 'Kunde wurde aktualisiert',
    this_company_does_not_have_any_users: 'Kunde hat noch keine Benutzer',
    DASHBOARD: 'DASHBOARD',
    PASSENGERS: 'GANGLINIE',
    Passengers: 'Passagiere',
    CAPACITY: 'KAPAZITÄT',
    passenger_capacity: 'Fahrgast-Kapazität',
    total_number_of_entries: 'Summe der Einstiege',
    maximum_occupancy: 'Maximalbelegung',
    RIDE_TIME: 'FAHRTZEITPROFILE',
    ROUTES: 'VERLAUFSKARTE',
    congestion: 'Stauzeiten',
    accessibility_of_stops: 'Erreichbarkeit Haltestellen',
    data_quality: 'HEATMAPS',
    average_number_of_passengers: 'Daten der Fahrgastzähler',
    normalised_average_number_of_passengers: 'Norm. Anzahl Passagiere',
    passenger_counter: 'Dursch. Passagier-Zahl',
    vehicle_deployment: 'FAHRZEUGEINSATZ',
    raised_rides_lines: 'Erhobene Fahrten | Linien',
    raised_rides_wum: 'Erhobene Fahrten | WUM',
    statistics: 'STATISTIK',
    analysis: 'HOCHRECHNUNGEN',
    Customers: 'Kunden',
    showRole: 'Role anzeigen',
    User: 'Benutzer',
    Logout: 'Abmelden',
    Settings: 'Einstellungen',
    myProfile: 'Eigenes Profil',
    welcome: 'Willkommen',
    myPersonalData: 'Persönliche Daten',
    myCompany: 'Meine Organisation verwalten',
    rightsManagement: 'Rechteverwaltung',
    superUserPage: 'Superuser-Zugriff',
    updateUser: 'Benutzer Bearbeiten',
    updateUsername: 'Benutzername Bearbeiten',
    save: 'Speichern',
    resetPassword: 'Passwort zurücksetzen',
    thisCredentials: 'diese Zugangsdaten',
    deleteCredentials: 'Zugangsdaten löschen',
    createNewCredentials: 'Neue Zugangsdaten erstellen',
    validTill: 'Gültig bis',
    Back: 'Zurück',
    credentials: 'Zugangsdaten',
    created: 'Erstellt',
    yes: 'Ja',
    no: 'Nein',
    allowLogin: ' Login erlauben',
    info: 'Info',
    privacyPolicy: 'Datenschutz',
    imprint: 'Impressum',
    brodtmannConsulting: 'Brodtmann Consulting',
    invalidCredentials: 'Logindaten nicht erkannt',
    signIn: 'ANMELDEN',
    password: 'Passwort',
    email: 'E-mail',
    username: 'Benutzername',
    company: 'Firma',
    longLoadingNotice: '...das dauert etwas länger als gedacht...',
    graphUpdating: 'Grafik wird aktualisiert...',
    Trips: 'Fahrten',
    uhr: 'Uhr',
  },
};

function getLanguage() {
  return 'en';
}

export let i18n = new VueI18n({
  locale: getLanguage(), // set locale
  fallbackLocale: 'en', // set fallback locale
  messages,
});
